"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateParseError = exports.OutOfRange = exports.ParamNotValid = exports.TypeNotValid = void 0;
// 类型异常
var TypeNotValid = /** @class */ (function (_super) {
    __extends(TypeNotValid, _super);
    function TypeNotValid(msg) {
        return _super.call(this, msg) || this;
    }
    return TypeNotValid;
}(Error));
exports.TypeNotValid = TypeNotValid;
// 参数异常 - 组件、方法入参
var ParamNotValid = /** @class */ (function (_super) {
    __extends(ParamNotValid, _super);
    function ParamNotValid(msg) {
        return _super.call(this, msg) || this;
    }
    return ParamNotValid;
}(Error));
exports.ParamNotValid = ParamNotValid;
// 整数范围越界
var OutOfRange = /** @class */ (function (_super) {
    __extends(OutOfRange, _super);
    function OutOfRange(msg) {
        return _super.call(this, msg) || this;
    }
    return OutOfRange;
}(Error));
exports.OutOfRange = OutOfRange;
// 日期格式解析异常
var DateParseError = /** @class */ (function (_super) {
    __extends(DateParseError, _super);
    function DateParseError(msg) {
        if (msg === void 0) { msg = "Date string parse error."; }
        return _super.call(this, msg) || this;
    }
    return DateParseError;
}(Error));
exports.DateParseError = DateParseError;
